import React from "react";

export const NoTranslationAvailable = () => (
  <div className="w-full rounded bg-red-500 text-center p-1">
    No translation available. Please contact us at&nbsp;
    <a href="mailto:hello@seabrook-studios.com">hello@seabrook-studios.com</a>
    &nbsp;if you are able to contribute a translation.
  </div>
);
